export default __webpack_public_path__ + "static/media/comment.df605a4a.svg";